import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useCargosCadastroPagination
 */

type State = {
  treinamentos: PaginationProperties,
  habilidades: PaginationProperties,
};

type Action = {
  treinamentosSetter: SetPaginationProperties,
  habilidadesSetter: SetPaginationProperties,
};

export const useCargosCadastroPagination = create<State & Action>((set) => ({
  treinamentos: InitializePaginationProperties({ rowsPerPage: 100 }),
  habilidades: InitializePaginationProperties({ rowsPerPage: 100 }),
  treinamentosSetter: InitializeSetPaginationProperties(set, 'treinamentos'),
  habilidadesSetter: InitializeSetPaginationProperties(set, 'habilidades'),
}));